var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bax-btn",class:[
        (_vm.color == 'primary') ? 'bax-btn-blue' : '',
        (_vm.color == 'link') ? 'bax-btn-bordered bax-btn-bordered-blue' : '',
        (_vm.color == 'default') ? 'bax-btn-bordered bax-btn-bordered-dark-gray-1' : '',
        (_vm.color == 'green') ? 'bax-btn bax-btn-green-3' : '',
        (_vm.isRound === true) ? 'bax-btn-round' : '',
    ],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }